<template>
    <section>
        <div class="card card-cascade narrower mb-r">
            <div class="view gradient-card-header pt-3 pb-3  primary-color "><h4>overrides</h4></div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <h4 class="card-title">when?</h4>

                        <!--Text-->
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="md-form">
                                    <i class="prefix fa fa-calculator active"></i>
                                    <input v-model="overrides.hours.before" id="start_time_override" type="text"
                                           name="override">
                                    <label class="active" for="start_time_override">hrs before event</label>
                                </div>
                                <div class="md-form">
                                    <i class="prefix fa fa-calculator active"></i>
                                    <input v-model="overrides.hours.after" id="end_time_override" type="text"
                                           name="override">
                                    <label class="active" for="end_time_override">hrs after event</label>
                                </div>
                            </div>
                            <div class="col-md-8">
                                select tickets
                                <div>
                                    <div @click="showModal('time')" class="btn btn-primary">choose</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <h4 class="card-title">how much?</h4>
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="md-form">
                                    <i class="prefix fa fa-gbp active"></i>
                                    <input v-model="overrides.price" id="price_override" type="text"
                                           name="override">
                                    <label class="active" for="price_override">price</label>
                                </div>
                            </div>
                            <div class="col-md-8">
                                select tickets
                                <div @click="showModal('price')" class="btn btn-primary">choose</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="select-ticket-override--modal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-danger" role="document">
                <!--Content-->
                <div class="modal-content">
                    <!--Header-->
                    <div class="modal-header">
                        <p class="heading">select tickets</p>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="white-text">×</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="btn btn-small btn-primary" @click="selected_all(true)">all</div>
                        <div class="btn btn-small btn-primary" @click="selected_all(false)">none</div>
                        {{tickets}}
                        <div v-for="ticketEntity in ticketsToEntities">
                            <div v-for="ticket in ticketEntity">
                                <div v-if="ticket.ticket_type == 'single'" class="form-group">
                                    <input v-model="tickets"
                                           :value="ticket.id"
                                           type="checkbox"
                                           :id="'selected-ticket--id-'+ticket.id" number>
                                    <label :for="'selected-ticket--id-'+ticket.id">{{langData('title',ticket.ticket_data)}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer justify-content-center">
                        <a type="button"
                           v-on:click="confirmOverride()"
                           data-dismiss="modal"
                           class="btn btn-primary-modal waves-effect"
                        >Confirm<i class="fa fa-cross ml-1"></i></a>

                        <a type="button"
                           class="btn btn-outline-secondary-modal waves-effect"
                           data-dismiss="modal"
                        >Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    // add imports here
    import {uniqueId} from "../../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds";
    //ADD JSDOC HERE!!!!!
    export default {
        props: ['ticketsToEntities', 'event_details','url', 'lang'],
        created() {
        },
        destroyed() {
        },
        mounted() {
            console.log('tickets', this.ticketsToEntities);
            console.log('event_details', this.event_details);
        },
        data() {
            return {
                ticketTypesSelected: ['single'],
                overrides: {
                    hours: {
                        before: 3,
                        after: 4
                    },
                    price: 0
                },
                // ç: {
                //     all: uniqueId('ticket_select--all'),
                //     none: uniqueId('ticket_select--none'),
                //     all_model: false,
                //     none_model: false
                // },
                select_ticket: false,
                tickets: [],
                override_type:''
            }
        },
        methods: {
            confirmOverride: function () {

                let data = {
                    tickets: this.tickets,
                    override_type: this.override_type
                },
                _this = this;
                if (this.override_type == 'time') {
                    data['values'] = {
                        'start': this.overrides.hours.before,
                        'end': this.overrides.hours.after,
                    }
                }
                else if (this.override_type == 'price') {
                    data['values'] = this.overrides.price
                }

                axios.post(this.url, data)
                    .then(function (response) {
                        console.log('response', response);
                        if (response.data.success) {

                            _this.$emit('event',{
                                action:'reload'
                            });
                        }
                    })
                    .catch(function () {
                        console.log('this', this);
                    });
            },
            selected_all(selected) {

                if (!selected) {
                    this.tickets = [];
                    return;
                }
                let selected_tickets = [];

                for (let entity in this.ticketsToEntities) {
                    let tickets = this.ticketsToEntities[entity];

                    for (let i = 0; i < tickets.length; i++) {
                        let ticket = tickets[i];

                        if (ticket.ticket_type == 'single') {
                            selected_tickets.push(ticket.id);
                        }
                    }

                }
                this.tickets = selected_tickets;

            },
            uniqueId(str) {
                return uniqueId(str);
            },
            showModal(what) {
                this.override_type = what;
                $('#select-ticket-override--modal').modal();
            },
            langData(id, data) {
                return data.lang[this.lang][id];
            },
        },
        computed: {}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/EventTicketOverride.vue?1d3babc6